<template>
  <v-row dense>
    <v-col
        v-for="category in getItemsCategories"
        :key="category.id"
        cols="12" :md="md"
    >
      <v-card elevation="2" class="mb-4">
        <!-- Header de categoría mejorado -->
        <v-card-title
          class="py-3"
          :style="{
            backgroundColor: category.backgroundColor || '#1976d2',
            color: category.fontColor || 'white'
          }"
        >

          <span class="text-h6 font-weight-bold">{{ category.name }}</span>
          <v-spacer></v-spacer>
          <v-chip
            small
            outlined
            :color="category.fontColor || 'white'"
            class="font-weight-bold"
          >
            {{ categoryItemsQuantity(category) }} items
          </v-chip>
        </v-card-title>

        <v-card-text class="pa-0">
          <v-list class="py-0">
            <!-- Items de la categoría -->
            <template v-for="(item, index) in getItemsByCategory(category)" >
              <v-list-item :key="item.product.id" class="px-4 py-3" :class="{ 'grey lighten-5': index % 2 === 0 }">
                <v-list-item-avatar size="56" class="mr-4">
                  <v-img
                    eager
                    :src="getImage(item, category)"
                    class="rounded-lg elevation-2"
                    :alt="item.product.name"
                  >
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-icon size="24" color="grey lighten-1">mdi-image</v-icon>
                      </v-row>
                    </template>
                  </v-img>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title class="text-body-1 font-weight-medium mb-1">
                    {{ item.product.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-body-2">
                    <v-chip
                      small
                      color="green"
                      text-color="white"
                      class="font-weight-bold"
                    >
                      <v-icon left small>mdi-currency-usd</v-icon>
                      {{ getPrice(item.product, category) }}
                    </v-chip>
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <v-chip
                    color="primary"
                    text-color="white"
                    class="font-weight-bold px-3"
                    label
                  >
                    <v-icon left small>mdi-package-variant</v-icon>
                    {{ item.quantity }}
                  </v-chip>
                </v-list-item-action>
              </v-list-item>

              <v-divider v-if="index < getItemsByCategory(category).length - 1" :key="`divider-${item.product.id}`"></v-divider>
            </template>
          </v-list>
        </v-card-text>

        <!-- Footer con total mejorado -->
        <v-card-actions
          class="px-4 py-3"
          :style="{
            backgroundColor: category.backgroundColor ? `${category.backgroundColor}20` : '#f5f5f5',
            borderTop: `2px solid ${category.backgroundColor || '#1976d2'}`
          }"
        >
          <v-spacer></v-spacer>
          <div class="text-right">
            <div class="text-body-2 grey--text text--darken-2 mb-1">
              Total {{ category.name }}
              <v-chip
                  large
                  :color="category.backgroundColor || 'primary'"
                  :text-color="category.fontColor || 'white'"
                  class="font-weight-bold px-4"
              >
                <v-icon left>mdi-calculator</v-icon>
                {{ categoryItemsQuantity(category) }} items
              </v-chip>
            </div>

          </div>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import CategoryMixin from "@/modules/delivery/mixins/CategoryMixin";
import ProductMixin from "@/modules/delivery/mixins/ProductMixin";

export default {
  name: "OrderItems",
  props: {
    items: {type: Array},
    sm: {type: String, default: '12'},
    md: {type: String, default: '12'},
    lg: {type: String, default: '12'},
  },
  mixins: [CategoryMixin, ProductMixin],
  computed: {
    getImage() {
      return (item, category) => {
        let imageCategory
        if (item.product.imageCategory) {
          imageCategory = item.product.imageCategory.find(i => i.category === category.id)
        }
        return (imageCategory && imageCategory.image) ? imageCategory.image : item.product.image
      }
    },
    categoryItemsQuantity() {
      return category => {
        return this.items.reduce((a, i) => {
          if (category.id === i.category.id) {
            return a + i.quantity
          }
          return a
        }, 0)
      }
    }
  }
}
</script>

<style scoped>
.v-card {
  transition: all 0.3s ease;
}

.v-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.15) !important;
}

.v-list-item {
  transition: background-color 0.2s ease;
}

.v-list-item:hover {
  background-color: rgba(0,0,0,0.04) !important;
}

.rounded-lg {
  border-radius: 8px !important;
}
</style>
